import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { ContatoCliente } from '../../../containers'

const Contato = (props) => {
  const { cliente } = props

  return (
    <div>
      <Switch>
        <Route
          exact path='/clientes/:clienteId/contatos'
          render={({match}) => (
            <ContatoCliente.Index
              cliente={cliente}
              match={match}
            />
          )}>
        </Route>
        <Route
          exact path='/clientes/:clienteId/contatos/new'
          render={({match}) => (
            <ContatoCliente.Form
              cliente={cliente}
              match={match}
            />
          )}
        />
        <Route
          exact path='/clientes/:clienteId/contatos/:id/edit'
          render={({match}) => (
            <ContatoCliente.Form
              cliente={cliente}
              match={match}
            />
          )}
        />
        <Route
          exact path='/clientes/:clienteId/contatos/:id'
          render={({match}) => (
            <ContatoCliente.Show
              cliente={cliente}
              match={match}
            />
          )}
        />
      </Switch>
    </div>
  )
}

Contato.propTypes = {
  cliente: PropTypes.object.isRequired,
}

export default Contato
